import * as React from 'react';
import { Grid, FormControl, TextField, FormControlLabel, Checkbox } from '@material-ui/core';
import { updateQuestionDataValue } from 'src/effects/utils/preview';
import { SurveyStatusEnum } from 'src/constants/Enum/SurveyStatusEnum';

export default class DatepickerTypeQuestionComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
        };

        this.onAnswerChange = this.onAnswerChange.bind(this);
    }

    setLocalState(props: any) {
        for (let index: number = 1; index <= props.question.class_type; index++) {
            const questionResponse = props.question.question_responses[index - 1];
            const defaultQuestionResponses = props.question.default_question_responses.find((resp: any) => resp.class_type === index); 

            if ((props.isReviewQuetion || !props.isResponsePage) && !questionResponse.value) {  
                questionResponse.value = defaultQuestionResponses && defaultQuestionResponses.value ? defaultQuestionResponses.value : ''; 
            }

            if (props.question.question_responses[index - 1] && this.state[props.pageNumber + '_' + props.questionId + "_" + index] !== questionResponse.value) {
                 
                this.setState({
                    [props.pageNumber + '_' + props.questionId + "_" + index]: questionResponse.value 
                });
            }
        }
    }

    componentDidMount() {
        this.setLocalState(this.props);
    }

    componentWillReceiveProps(nextProps: any) {
        this.setLocalState(nextProps);
    }

    onAnswerChange(classType: any, event: any) {
        this.setState({ [event.target.name]: event.target.value });
        if (!this.props.isReviewQuetion) {
            updateQuestionDataValue(this.props, classType, event.target.value, false, null, true, []);
        }
    }

    onUncheckedChange(classType: any, txtName: any, event: any) {
        this.setState({ [event.target.name]: event.target.checked });
        this.setState({ [txtName]: "" });

        if (!event.target.checked) {
            this.setState({ [this.props.pageNumber + '_' + this.props.questionId + "_" + classType + "isDisabled"]: false });
        }
        else {
            this.setState({ [this.props.pageNumber + '_' + this.props.questionId + "_" + classType + "isDisabled"]: true });
        }

        if (!this.props.isReviewQuetion) {
            updateQuestionDataValue(this.props, classType, '', event.target.checked, null, true, []);
        }
    }

    renderQuestion() {
        const elements: any = [];
        if (this.props && this.props.question.class_type !== undefined) {
            for (let index: number = 1; index <= 3; index++) {
               

                    elements.push(<Grid key={this.props.pageNumber + '_' + this.props.questionId + "_label_" + index} item={true} sm={4} className="pb-0">
                        <FormControl margin="normal" fullWidth={true}>
                            <label>
                                {
                                    index === 1 ?
                                        (this.props.question.question_one_title ? this.props.question.question_one_title.en : '') :
                                        index === 2 ?
                                            (this.props.question.question_two_title ? this.props.question.question_two_title.en : '')
                                            :
                                            (this.props.question.question_three_title ? this.props.question.question_three_title.en : '')
                                }
                            </label>
                        </FormControl>
                        </Grid>
                            )
                            }
                            
            for (let index: number = 1; index <= this.props.question.class_type; index++) {
                if (this.state[this.props.pageNumber + '_' + this.props.questionId + "_" + index] !== undefined) {
                    const isDisabled = this.state[this.props.pageNumber + '_' + this.props.questionId + "_" + index + "isDisabled"]; 
                    const defaultQuestionResponses = this.props.question.default_question_responses && this.props.question.default_question_responses.find((resp: any) => resp.class_type === index);  
                    const isEditable = this.props.isResponsePage && this.props.surveyType === 1 ? true : defaultQuestionResponses && (defaultQuestionResponses.value || (defaultQuestionResponses.value + '').length > 0) ? defaultQuestionResponses.is_Editable : true;     

                    elements.push(<Grid key={this.props.pageNumber + '_' + this.props.questionId + "_" + index} item={true} sm={4} >
                        <FormControl margin="normal" fullWidth={true}>
                            <TextField
                                margin="normal"
                                variant="outlined"
                                type="date"
                                disabled={this.props.surveyStatus === SurveyStatusEnum.Finished || isDisabled || !isEditable} 
                                name={this.props.pageNumber + '_' + this.props.questionId + "_" + index}
                                value={this.state[this.props.pageNumber + '_' + this.props.questionId + "_" + index]}
                                autoFocus={false}
                                onChange={this.onAnswerChange.bind(this, index)}
                            />
                            {this.props.question.show_unavailable_checkbox &&
                                <FormControlLabel key={this.props.pageNumber + '_' + this.props.questionId + "_" + index + "_" + "Unavailable"}
                                    control={
                                        <Checkbox
                                            disabled={this.props.surveyStatus === SurveyStatusEnum.Finished}
                                            key={this.props.pageNumber + '_' + this.props.questionId + "_" + index + "_" + "Unavailable"}
                                            name={this.props.pageNumber + '_' + this.props.questionId + "_" + index + "_" + "Unavailable"}
                                            checked={this.state[this.props.pageNumber + '_' + this.props.questionId + "_" + index + "_" + "Unavailable"]}
                                            onChange={this.onUncheckedChange.bind(this, index, this.props.questionId + "_" + index)}
                                            value={"Unavailable"}
                                            color="primary"
                                        />
                                    }
                                    label="Unavailable"
                                />
                            }
                        </FormControl>
                    </Grid>);
                }
            }
        }
        return elements;
    }

    render() {
        return (
            <>
                {
                    this.renderQuestion()
                }
            </>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/responses/QuestionTypes/DatepickerTypeQuestionComponent.tsx